import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-bill',
  templateUrl: './bill.component.html',
  styleUrls: ['./bill.component.scss']
})
export class BillComponent implements OnInit {

bill:any = {
				status:0, patient:"", patient_id:0, type:{id:0, name:""},
				bill_no:"",
				bill_no_prefix:"",
				suggested_discount:{
					amount:"",
					doctor:{
						id:0,
						name:""
					},
					discount_approved:0
				},
				discount_preset:{
					id:0,
					name:"",
					percentage:0
				}
			};
id:any = '0';
therapists:any = [];
selectedTherapist:any = 0;	
branch:any = {id:0, name:""};
logo:any = null;
address:any = "";
selectedPaymentMode:any = "";
selectedReturnItem:any = {};
billStatuses:any = [
	{id:0, name:"Chargeable"},
	{id:1, name:"Complementary"},
	{id:2, name:"VSSC"}
];
walletBalance:any = 0;

pharmaLabels:any = [
    "",
	"Normal",
	"Courier",
	"Home Delivery"
];

pharmacyLabels:any = [
    {
      id:1,
      label:"Normal"
    },
    {
      id:2,
      label:"Courier"
    },
    {
      id:3,
      label:"Home Delivery"
    },
  ];
discountPresets:any = [];
selectedDiscountPreset:any = 0;
labels:any = [];

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService, private location: Location) { }

  ngOnInit() {

	this.id = (this.route.snapshot.paramMap.get('id') != null) ? this.route.snapshot.paramMap.get('id') : 0;
	this.branch = (localStorage.getItem("branch") != null) ? JSON.parse(localStorage.getItem("branch")) : {id:0, name:""}; 

  	this.loadBill();
	this.loadTherapists();
	this.loadLogo();
	this.loadDiscountPresets();
	this.loadBillLabels();
  }

  loadBill(){

  	this.dataService.getSingleBill(this.id).subscribe( (data: any )=> {
		this.bill = data.data;
		console.log("bill data", this.bill);
		this.loadWalletBalance();
	});

  }

  loadBillLabels(){
    this.dataService.getBillLabels().subscribe( (data: any  )=> {
      this.labels = data
    });
  }

  loadDiscountPresets(){
	this.dataService.getDiscountPresets().subscribe( (data: any )=> {
		this.discountPresets = data;
		
	});
  }

  loadWalletBalance(){
	this.dataService.getClientWalletBalance(this.bill.patient_id).subscribe( (data: any )=> {
		if(data.status == 0){
			this.walletBalance = data.balance;
		}
		
	});
  }

  loadTherapists(){
    this.dataService.getTherapists(this.branch.id).subscribe( (data: any = {status:0} )=> {
      if(data.status == 0){
        this.therapists = data;
      }
      
      
    });
  }

loadLogo(){
	this.dataService.getLogoData().subscribe( (data: any = {status:0, logo_data:""} )=> {
		if(data.status == 0){
			this.logo = data.logo_data;
			this.address = data.address;
		}
		
		
	});
}

submitCons(data){
	data.bill_id = this.id;
	data.field = "consultant_id";
	this.dataService.postUpdateBill(data).subscribe( (res:any) => {
		if(res.status == 0) {
		$("#modal-edit-cons").modal('hide');
		$(".btn-close-modal").trigger("click");
		  this.loadBill();
		} else {
		  alert(res.msg);
		}

	  }); 

}

submitLabel(data){
	data.bill_id = this.id;
	data.field = "label_id";
	this.dataService.postUpdateBill(data).subscribe( (res:any) => {
		if(res.status == 0) {
		$("#modal-edit-label").modal('hide');
		$(".btn-close-modal").trigger("click");
		  this.loadBill();
		} else {
		  alert(res.msg);
		}

	  }); 

}


submitPharmaLabel(data){
	data.bill_id = this.id;
	data.field = "pharma_label_id";
	this.dataService.postUpdateBill(data).subscribe( (res:any) => {
		if(res.status == 0) {
		$("#modal-edit-pharmalabel").modal('hide');
		$(".btn-close-modal").trigger("click");
		  this.loadBill();
		} else {
		  alert(res.msg);
		}

	  }); 

}

submitPm(data){
	
	
	if(data.mode != 0){
		data.bill_id = this.bill.id;
		this.dataService.postMarkBillPaid(data).subscribe( (res:any) => {
		if(res.status == 0) {
			  alert(res.msg);
			
			this.loadBill();
			$("#modal-edit-pm").modal('hide');
			$(".btn-close-modal").trigger("click");
		} else {
		  alert(res.msg);
		}
		} );
	} else {
		alert("Select a mode of payment to continue.");
	}
	
  }

submitDiscount(data){
	if(!isNaN(data.discount)){

		data.bill_id = this.bill.id;
		this.dataService.postUpdateBillDiscount(data).subscribe( (res:any) => {
		if(res.status == 0) {
			alert(res.msg);
			this.loadBill();
			$("#modal-edit-discount").modal('hide');
			$(".btn-close-modal").trigger("click");
		} else {
		  alert(res.msg);
		}
		} );

	} else {
		alert("Discount must be a number");
	}
}

submitSuggestedDiscount(data){
	if(!isNaN(data.discount)){

		data.bill_id = this.bill.id;
		this.dataService.postUpdateBillSuggestedDiscount(data).subscribe( (res:any) => {
		if(res.status == 0) {
			alert(res.msg);
			this.loadBill();
			$("#modal-edit-discount").modal('hide');
			$(".btn-close-modal").trigger("click");
		} else {
		  alert(res.msg);
		}
		} );

	} else {
		alert("Discount must be a number");
	}
}

cancelDiscountSuggestion(){
	var cnf = confirm("Do you really want to cancel this discount suggestion?");
	if(cnf){
		let data = {
			bill_id: this.bill.id,
			discount:0
		}

		this.dataService.postUpdateBillSuggestedDiscount(data).subscribe( (res:any) => {
			if(res.status == 0) {
				alert("Discount suggestion cancelled");
				this.loadBill();
				$("#modal-edit-discount").modal('hide');
				$(".btn-close-modal").trigger("click");
			} else {
			  alert(res.msg);
			}
			} );
	}
}

ignoreDiscountSuggestion(){
	var cnf = confirm("Do you really want to ignore this discount suggestion?");
	if(cnf){
		let data = {
			bill_id: this.bill.id,
			
		}

		this.dataService.postBillIgnoreSuggestedDiscount(data).subscribe( (res:any) => {
			if(res.status == 0) {
				alert(res.msg);
				this.loadBill();
				$("#modal-edit-discount").modal('hide');
				$(".btn-close-modal").trigger("click");
			} else {
			  alert(res.msg);
			}
			} );
	}
}

applyDiscountSuggestion(){
	var cnf = confirm("Do you really want to apply this discount suggestion?");
	if(cnf){
		let data = {
			bill_id: this.bill.id,
		}

		this.dataService.postBillApplySuggestedDiscount(data).subscribe( (res:any) => {
			if(res.status == 0) {
				alert(res.msg);
				this.loadBill();
				$("#modal-edit-discount").modal('hide');
				$(".btn-close-modal").trigger("click");
			} else {
			  alert(res.msg);
			}
			} );
	}
}


selectReturnItem(item){
	this.selectedReturnItem = item;
	
}

submitReturn(input){
	console.log(input);
	let allowed = this.selectedReturnItem.qty - this.selectedReturnItem.returned;
	if(input.current_return > allowed){
		
		alert("You can't return more than " + allowed + " quantity of this item" );
	} else {
		let data = {
			bill_id:this.bill.id,
			bc_id:this.selectedReturnItem.id,
			stock_id:this.selectedReturnItem.stock_id,
			return_qty:input.current_return,
			rate:this.selectedReturnItem.rate
		}

		this.dataService.postPatientReturnStock(data).subscribe( (res:any) => {
			if(res.status == 0) {
				alert(res.msg);
				this.loadBill();
				$(".btn-close-modal").trigger("click");
			} else {
			  alert(res.msg);
			}
			} );

		
	}
}


  /*print */

  printTbcBill(){
	//@ts-ignore
	var doc = new jsPDF();
	var y = 10;
	var yr = 30;

	//Logo
	doc.addImage(this.logo, 'PNG', 30,0,56,22); 
	y+=30; yr+=20;
	doc.setFontSize(10);
	doc.setFontType('bold');
	doc.text(100, y, 'Tax Invoice');
	y+=10;

	//from
	doc.setFontSize(8);
	doc.text(10,y, "Talking Brains Center FZE");
	y+=5;
	doc.setFontType('normal');
	doc.text(10,y, "Office 505, 5/F, Apricot Tower,");
	y+=5;
	doc.text(10,y, "Silicon Oasis,");
	y+=5;
	doc.text(10,y, "Dubai, UAE.");
	y+=5;
	doc.text(10,y, "Emirate: Dubai");
	y+=5;
	doc.text(10,y, "TRN: 100332404100003");

	//buyer
	y+=10;
	doc.text(10, y, "Paid by");
	y+=5;
	doc.setFontType('bold');
	doc.text(10, y, this.bill.patient);
	doc.setFontType('normal');
	y+=5;
	doc.text(10,y, this.bill.phone);
	y+=5;
	doc.text(10,y, "Emirate:");
	doc.text(35, y, this.bill.city);
	y+=5;
	doc.text(10,y, "Country:");
	doc.text(35,y, this.bill.country);
	y+=5;
	doc.text(10,y, "Place of Supply:");
	doc.text(35,y, "Dubai, UAE");

	//right side of header
	doc.setFontType('bold');
	doc.text(135, yr, "Invoice No.");
	doc.text(169, yr, "Dated");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135, yr, this.bill.bill_no.toString());
	doc.text(169, yr, this.bill.bill_date);
	
	yr+=10;
	doc.setFontType('bold');
	doc.text(135, yr, "Therapist");
	doc.text(169, yr, "Mode of Payment");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135,yr, this.bill.consultant);
	doc.text(169, yr, this.bill.payment_mode);

	//particulars

	y+=10;
	doc.setFontType('bold');
	doc.text(10,y, "Sl No.");
	doc.text(26, y, "Particulars");
	doc.text(121, y, "Quantity", 'right');
	doc.text(140, y, "Rate", 'right');
	doc.text(159, y, "Amount", 'right');
	doc.text(185, y, "VAT %", 'right');

	doc.setFontType('normal');
	y+=7;
	var counter = 1;
	this.bill.contents.forEach(element => {
		doc.text(10,y, counter.toString());
		doc.text(26, y, element.description);
		doc.text(121, y, element.qty.toString(), 'right' );
		doc.text(140, y, element.rate.toString(), 'right');
		doc.text(159, y, element.amount.toString(), 'right');
		doc.text(185, y, "0%", 'right');
		
		if(this.bill.type == 2){
			doc.text(26, y+5, "Batch: " + element.batch + " Expiry: " + element.expiry );
			
			y += 10;
		} else {
			y+=5;
		}
		
		
		counter++;
	});

	
	
	
	

	//Total;

	doc.setFontType('bold');
	y+=20;
	doc.text(121, y, "Total", 'right');
	doc.setFontSize(10);
	doc.text(159, y, "AED "+this.bill.total.toString(), 'right');

	doc.setFontType('normal');
	doc.setFontSize(8);

	y+=10;
	doc.text(10, y, "Amount chargeable (in words)");
	y+=5;
	doc.setFontSize(9);
	doc.setFontType('bold');
	//@ts-ignore
	doc.text(10, y, "UAE Dirham "+number2words(this.bill.total)+" Only (AED " +this.bill.total.toString() + ")"  );
	
	


	//output
	var string = doc.output('datauristring');
	var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
	newWindow.document.write(
	'<html><body><center>' +
	
	'</center><br>' +
	'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
	'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
	'</object></body></html>');
	newWindow.window.focus();

  }

  printTbcReceipt(){
	//@ts-ignore
	var doc = new jsPDF("l", "mm", [148,210]);
	var y = 10;
	var yr = 30;

	//Logo
	doc.addImage(this.logo, 'PNG', -20,0,155,37); // logo dimensions: 210x50mm

	doc.setFontSize(12);
	doc.setFontStyle('italic');
	y += 2;
	doc.text("Office 505, Appricot Tower, Silicon Oasis, Dubai", 195, y, 'right');
	y +=6;
	doc.text("P.O Box: 393984, 04 320 9307 / 055 896 7482", 195, y, 'right');
	y +=6;
	doc.text("www.talkingbrainscenter.com", 195, y, 'right');
	y +=6;
	doc.text("TRN: 100332404100003", 195, y, 'right');

	y += 15;
	doc.setFontStyle('normal');

	doc.text("Date: " + this.bill.bill_date, 10, y);
	doc.text("Receipt No.: " + this.bill.bill_no.toString(), 195, y, 'right');

	y += 25;
	var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
	var ParaWidth=pageWidth*0.95; /* para width will 85% of the page width. */

	let receiptBody = "We have received from Mr./Mrs. "+this.bill.payer_name+" for his/her son/daughter/himself "+this.bill.patient+" an amount of AED "+this.bill.payable+" for the following service/s provided in the center:";

	
	
	var lines = doc.splitTextToSize(receiptBody, ParaWidth);
	doc.text(10, y , lines);
	console.log("lines", lines);

	y += 5*(lines.length + 1);

	//let description = "Description: Speech therapy (therapist: Reine Bou Issa; Duration: 60 minutes), Occupational therapy (therapist: Reine Bou Issa; Duration: 60 minutes)";

	let description = "Description: ";

	this.bill.contents.forEach(row => {
		description += row.description;
		if(row.therapist.length > 0 || row.duration.length > 0)	{
			description += " (";

			if(row.therapist.length > 0){
				description += "Therapist: " + row.therapist + "; ";
			}

			if(row.duration.length > 0){
				description += "Duration: " + row.duration;
			}

			description += ")";
		}
		description += ". ";
	});

	var lines = doc.splitTextToSize(description, ParaWidth);
	doc.text(10, y , lines);

	y += 5*(lines.length + 1);

	if(this.bill.is_paid == 1){
		doc.text("Payment made by: " + this.bill.payment_mode, 10, y);	
	}
	

	let yfooter = 135;

	doc.line(10, yfooter, 80, yfooter);
	doc.text("Payment received by", 20, yfooter+5);

	doc.line(120, yfooter, 200, yfooter);
	doc.text("Authorized signature", 140, yfooter+5);


	//output
	var string = doc.output('datauristring');
	var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
	newWindow.document.write(
	'<html><body><center>' +
	
	'</center><br>' +
	'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
	'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
	'</object></body></html>');
	newWindow.window.focus();

  }

  printBill(){
	//@ts-ignore
	//var doc = new jsPDF();
	var doc = new jsPDF('l', 'mm', [148, 210]);

	

	var y = 0;
	var yr = 20;
	
	//Logo
	/*if(this.logo != null){
		doc.addImage(this.logo, 'PNG', 80,5,56,22); // logo dimensions: 210x50mm
		y+=30; yr+=20;
	} */
	
	y+=35; yr+=15; //Top Margin;
	
	/*doc.setFontSize(10);
	doc.setFontType('bold');
	doc.text(100, y, 'Invoice');
	y+=10; */

	//from
	doc.setFontSize(8);
	

	//buyer
	//y+=10;
	doc.setFontType('bold');
	doc.text(10, y, "Patient");
	y+=5;
	doc.setFontType('normal');
	let patientName = "";
	if(this.bill.patient_id != 0){
		patientName = this.bill.patient + " ("+this.bill.reg_no+")"
	} else {
		patientName = this.bill.external_name;
	}
	doc.text(10, y, patientName);
	
	y+=5;
	let phoneRow = "";
	if(this.bill.patient_phone != null){
		phoneRow += "Phone: " + this.bill.patient_phone;
	}

	if(this.bill.patient_age != null){
		phoneRow += " Age: " + this.bill.patient_age;
	}

	if(phoneRow.length > 0){
		doc.text(10,y, phoneRow);
		y+=5;
	}

	
	let billNo = "";

	if(this.bill.bill_no_prefix.length > 0){
		billNo += this.bill.bill_no_prefix+"/";
	}

	billNo += this.bill.bill_no.toString();

	
	
	
	//right side of header
	doc.setFontType('bold');
	doc.text(135, yr, "Invoice No.");
	doc.text(169, yr, "Date");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135, yr, billNo);
	doc.text(169, yr, this.bill.bill_date);
	
	yr+=10;
	doc.setFontType('bold');
	doc.text(135, yr, "Consultant");
	doc.text(169, yr, "Mode of Payment");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135,yr, this.bill.consultant);
	doc.text(169, yr, this.bill.payment_mode);

	//particulars
	y+=10;

	y+=10;
	doc.setFontType('bold');
	doc.text(10,y, "Sl No.");
	doc.text(26, y, "Particulars");
	if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
		doc.text(135, y, "HSN/SAC", 'right');
	}
	
	doc.text(151, y, "Quantity", 'right');
	doc.text(170, y, "Rate", 'right');
	doc.text(189, y, "Amount", 'right');
	

	doc.setFontType('normal');
	y+=7;
	var counter = 1;
	this.bill.contents.forEach(element => {
		doc.text(10,y, counter.toString());
		doc.text(26, y, element.description);
		if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
			doc.text(135, y,  element.hsn_code.toString(), 'right');
		}
		doc.text(151, y, element.qty.toString(), 'right' );
		doc.text(170, y, element.rate.toString(), 'right');
		doc.text(189, y, element.amount.toString(), 'right');
		
		if(this.bill.type == 2){
			console.log("pharma bill");
			doc.text(26, y+5, "Batch: " + element.batch + " Expiry: " + element.expiry );
			
			y += 10;
		} else {
			y+=5;
		}
		counter++;
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
	});

	
	
	
	

	//Total;

	doc.setFontType('bold');
	y+=15;
	let yl = y;
	doc.text(151, y, "Total", 'right');
	doc.setFontSize(10);
	doc.text(189, y, this.bill.short_c +" "+this.bill.total.toString(), 'right');

	if(y >= 130){
		doc.addPage();
		y = 30;
	}

	if( Number(this.bill.discount) != 0){

		doc.setFontSize(8);
		y+=7;
		doc.text(151, y, "Discount", 'right');
		doc.setFontSize(10);
		doc.text(189, y, this.bill.short_c +" "+this.bill.discount.toString(), 'right');
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
		doc.setFontSize(8);
		y+=7;
		doc.text(151, y, "Payable", 'right');
		doc.setFontSize(10);
		doc.text(189, y, this.bill.short_c +" "+this.bill.payable.toString(), 'right');
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
	}

	if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
		doc.setFontSize(8);
		y+=7; 
		doc.text(151, y, "CGST", 'right');
		doc.text(189, y, this.bill.short_c +" "+this.bill.cgst.toString(), 'right');
		y+=5;
		doc.text(151, y, "SGST", 'right');
		doc.text(189, y, this.bill.short_c +" "+this.bill.sgst.toString(), 'right');
	}

	



	doc.setFontType('normal');
	doc.setFontSize(8);

	//y+=10;
	doc.text(10, yl, "Amount payable (in words)");
	yl+=5;
	doc.setFontSize(9);
	doc.setFontType('bold');

	//@ts-ignore
	let amountWords = this.bill.long_c+" "+number2words(this.bill.payable)+" Only ("+this.bill.short_c+ " " + this.bill.payable.toString() + ")"; 
	
	var amountWordsSplit = doc.splitTextToSize(amountWords, 120);
	doc.text(10, yl, amountWordsSplit);
	
	


	//output
	var string = doc.output('datauristring');
	var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
	newWindow.document.write(
	'<html><body><center>' +
	
	'</center><br>' +
	'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
	'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
	'</object></body></html>');
	newWindow.window.focus();

  }

  downloadBill(){
	//@ts-ignore
	//var doc = new jsPDF();
	var doc = new jsPDF('l', 'mm', [148, 210]);

	let logo = "data:image/jpeg;base64,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"; // Base64 data URL will be added here later

	var y = 0;
	var yr = 8;
	
	//Logo - positioned on left side
	if(logo != ""){
		const logoWidth = 50;
		const logoHeight = 19;
		doc.addImage(logo, 'PNG', 10, yr, logoWidth, logoHeight);
	}
	
	//Clinic information on the right side of header
	doc.setFontSize(9);
	doc.setFontType('bold');
	doc.text(200, yr, "DR. YOGIRAJ CENTRE FOR DERMATOLOGY", 'right');
	yr+=5;
	doc.text(200, yr, "AND COSMETOLOGY", 'right');
	yr+=5;
	doc.setFontType('normal');
	doc.setFontSize(8);
	doc.text(200, yr, "Opp. Vydyuthi Bhavan", 'right');
	yr+=5;
	doc.text(200, yr, "Pattom, Thiruvananthapuram", 'right');
	yr+=5;
	doc.text(200, yr, "Email ID: ycdcmail@yahoo.com", 'right');
	yr+=5;
	doc.text(200, yr, "GSTIN: 32AADFY6302J1ZA", 'right');
	yr+=3;
	
	//Horizontal line after header
	doc.line(10, yr, 200, yr);
	
	y+=40; yr+=15; //Top Margin;
	
	/*doc.setFontSize(10);
	doc.setFontType('bold');
	doc.text(100, y, 'Invoice');
	y+=10; */

	//from
	doc.setFontSize(8);
	

	//buyer
	//y+=10;
	doc.setFontType('bold');
	doc.text(10, y, "Patient");
	y+=5;
	doc.setFontType('normal');
	let patientName = "";
	if(this.bill.patient_id != 0){
		patientName = this.bill.patient + " ("+this.bill.reg_no+")"
	} else {
		patientName = this.bill.external_name;
	}
	doc.text(10, y, patientName);
	
	y+=5;
	let phoneRow = "";
	if(this.bill.patient_phone != null){
		phoneRow += "Phone: " + this.bill.patient_phone;
	}

	if(this.bill.patient_age != null){
		phoneRow += " Age: " + this.bill.patient_age;
	}

	if(phoneRow.length > 0){
		doc.text(10,y, phoneRow);
		y+=5;
	}

	
	let billNo = "";

	if(this.bill.bill_no_prefix.length > 0){
		billNo += this.bill.bill_no_prefix+"/";
	}

	billNo += this.bill.bill_no.toString();

	
	
	
	//right side of header
	doc.setFontType('bold');
	doc.text(135, yr, "Invoice No.");
	doc.text(169, yr, "Date");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135, yr, billNo);
	doc.text(169, yr, this.bill.bill_date);
	
	yr+=10;
	doc.setFontType('bold');
	doc.text(135, yr, "Consultant");
	doc.text(169, yr, "Mode of Payment");
	doc.setFontType('normal');
	yr+=5;
	doc.text(135,yr, this.bill.consultant);
	doc.text(169, yr, this.bill.payment_mode);

	//particulars
	y+=10;

	y+=10;
	doc.setFontType('bold');
	doc.text(10,y, "Sl No.");
	doc.text(26, y, "Particulars");
	if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
		doc.text(135, y, "HSN/SAC", 'right');
	}
	
	doc.text(151, y, "Quantity", 'right');
	doc.text(170, y, "Rate", 'right');
	doc.text(189, y, "Amount", 'right');
	

	doc.setFontType('normal');
	y+=7;
	var counter = 1;
	this.bill.contents.forEach(element => {
		doc.text(10,y, counter.toString());
		doc.text(26, y, element.description);
		if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
			doc.text(135, y,  element.hsn_code.toString(), 'right');
		}
		doc.text(151, y, element.qty.toString(), 'right' );
		doc.text(170, y, element.rate.toString(), 'right');
		doc.text(189, y, element.amount.toString(), 'right');
		
		if(this.bill.type == 2){
			console.log("pharma bill");
			doc.text(26, y+5, "Batch: " + element.batch + " Expiry: " + element.expiry );
			
			y += 10;
		} else {
			y+=5;
		}
		counter++;
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
	});

	
	
	
	

	//Total;

	doc.setFontType('bold');
	y+=15;
	let yl = y;
	doc.text(151, y, "Total", 'right');
	doc.setFontSize(10);
	doc.text(189, y, this.bill.short_c +" "+this.bill.total.toString(), 'right');

	if(y >= 130){
		doc.addPage();
		y = 30;
	}

	if( Number(this.bill.discount) != 0){

		doc.setFontSize(8);
		y+=7;
		doc.text(151, y, "Discount", 'right');
		doc.setFontSize(10);
		doc.text(189, y, this.bill.short_c +" "+this.bill.discount.toString(), 'right');
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
		doc.setFontSize(8);
		y+=7;
		doc.text(151, y, "Payable", 'right');
		doc.setFontSize(10);
		doc.text(189, y, this.bill.short_c +" "+this.bill.payable.toString(), 'right');
		if(y >= 130){
			doc.addPage();
			y = 30;
		}
	}

	if(this.dataService.localData.gstBilling == 1 && (this.bill.type.id == 2 || this.bill.type.id == 7 || this.bill.type.id == 8 || this.bill.type.id == 6)){
		doc.setFontSize(8);
		y+=7; 
		doc.text(151, y, "CGST", 'right');
		doc.text(189, y, this.bill.short_c +" "+this.bill.cgst.toString(), 'right');
		y+=5;
		doc.text(151, y, "SGST", 'right');
		doc.text(189, y, this.bill.short_c +" "+this.bill.sgst.toString(), 'right');
	}

	



	doc.setFontType('normal');
	doc.setFontSize(8);

	//y+=10;
	doc.text(10, yl, "Amount payable (in words)");
	yl+=5;
	doc.setFontSize(9);
	doc.setFontType('bold');

	//@ts-ignore
	let amountWords = this.bill.long_c+" "+number2words(this.bill.payable)+" Only ("+this.bill.short_c+ " " + this.bill.payable.toString() + ")"; 
	
	var amountWordsSplit = doc.splitTextToSize(amountWords, 120);
	doc.text(10, yl, amountWordsSplit);
	
	


	//output
	var string = doc.output('datauristring');
	var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
	newWindow.document.write(
	'<html><body><center>' +
	
	'</center><br>' +
	'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
	'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
	'</object></body></html>');
	newWindow.window.focus();

  }


  submitBillCancel(data) {
	//@ts-ignore
	data.bill_id = this.id;
	this.bill.is_cancelled = 1;
	this.dataService.postCancelBill(data).subscribe( (res:any) => {

		if(res.status == 0) {
		alert(res.msg);
		$('#modal-cancel-bill').modal('hide');
		$(".btn-close-modal").trigger("click");
		
		this.loadBill();
		} else {
		alert(res.msg);
		}

	} ); 


 }

 updatePayer(){
	let input = prompt("Enter payer name", this.bill.payer_name);

	if(input){
		let data = {patient_id:this.bill.patient_id, payer_name:input}
		this.dataService.postUpdatePayerName(data).subscribe( (res:any) => {

			if(res.status == 0) {
				this.bill.payer_name = input;
			} else {
				alert(res.msg);
			}
	
		} ); 
	}

 }

 submitBillComplementaryStatus(data){
	data.bill_id = this.bill.id;
	this.dataService.postBillComplementaryStatus(data).subscribe( (res:any) => {

		if(res.status == 0) {
			this.bill.complementary_status = data.billStatus;
			$(".btn-close-modal").trigger("click");
		} else {
			alert(res.msg);
		}

	} ); 
 }

 submitBillDate(data){
	data.bill_id = this.bill.id;
	this.dataService.postUpdateBillDate(data).subscribe( (res:any) => {

		if(res.status == 0) {
			this.bill.bill_date = res.bill_date;
			this.bill.bill_date_ = res.bill_date_;
			$(".btn-close-modal").trigger("click");
		} else {
			alert(res.msg);
		}

	} ); 
 }

 submitPresetDiscount(){
	
	let data = {
		bill_id:this.id,
		preset_id:this.selectedDiscountPreset
	}

	this.dataService.postBillPresetDiscount(data).subscribe( (res:any) => {

		if(res.status == 0) {
			this.loadBill();
			$(".btn-close-modal").trigger("click");
		} else {
			alert(res.msg);
		}

	} ); 
 }

 isDiscountEditable(): boolean {
  // Admin can always edit (roleId == 1)
  if (this.dataService.localData.roleId == "1") {
    return true;
  }
  
  // Check if timestamp_raw exists
  if (!this.bill.timestamp_raw) {
    return false;
  }
  
  // Parse the timestamp_raw (Y-m-d H:i:s format)
  const billCreatedAt = new Date(this.bill.timestamp_raw);
  const currentTime = new Date();
  
  // Calculate difference in minutes
  const diffInMs = currentTime.getTime() - billCreatedAt.getTime();
  const diffInMinutes = diffInMs / (1000 * 60);
  
  // Allow editing within 5 minutes
  return diffInMinutes <= 5;
}

 editExtName(){
    let input = prompt("External Patient Name", this.bill.external_name);

    if(input){

      let data = {id:this.id, name: input}

      this.dataService.postEditBillExtName(data).subscribe( (res:any) => {
        
        if(res.status == 0) {
          //this.loadBill();
		  this.bill.external_name = input;
          
        } else {
          alert(res.msg);
        } 
  
  
      });
    }

  }

  editExtPhone(){
    let input = prompt("External Patient Phone", this.bill.external_phone);

    if(input){

      let data = {id:this.id, phone: input}

      this.dataService.postEditBillExtPhone(data).subscribe( (res:any) => {
        
        if(res.status == 0) {
          //this.loadBill();
		  this.bill.external_phone = input;
          
        } else {
          alert(res.msg);
        } 
  
  
      });
    }

  }

  reCalculate(){
	var cnf = confirm("Confirm this action");

	if(cnf){
		let data = {id:this.id}

		this.dataService.postRecalculatePharmaBillTotal(data).subscribe( (res:any) => {
        
			if(res.status == 0) {
			  this.loadBill();
			  
			  
			} else {
			  alert(res.msg);
			} 
	  
	  
		  });

	}
  }

  editRate(row){
	let input = prompt("Update amount", row.rate);

	if(input){
		let data = {
			rowId:row.id,
			rate:input
		}
		this.dataService.postUpdateBCAmount(data).subscribe( (res:any) => {
        
			if(res.status == 0) {
			  this.loadBill();
			  
			  
			} else {
			  alert(res.msg);
			} 
	  
	  
		  });
	}

	

  }

  deleteRow(row){
	let cnf = confirm("Are you sure you want to remove this item from bill?");

	if(cnf){
		let data = {
			rowId:row.id,
			
		}
		this.dataService.postUpdateBCRemove(data).subscribe( (res:any) => {
        
			if(res.status == 0) {
			  this.loadBill();
			  
			  
			} else {
			  alert(res.msg);
			} 
	  
	  
		  });
	}

	

  }

  refundItem(row){
	let cnf = confirm("Are you sure you want to refund this item?");

	if(cnf){
		let data = {
			rowId:row.id,
			
		}
		this.dataService.postUpdateBCRefund(data).subscribe( (res:any) => {
        
			if(res.status == 0) {
			  this.loadBill();
			  
			  
			} else {
			  alert(res.msg);
			} 
	  
	  
		  });
	}

	

  }


  refundDone(){
	//let cnf = confirm("Confirm refund");
	let input = prompt("Enter reason for refund");
	if(input){
		let data = {bill_id:this.id, reason:input};

		this.dataService.postUpdateBillRefund(data).subscribe( (res:any) => {
        
			if(res.status == 0) {
			  this.bill.refund_done = res.refund_done;
			} else {
			  alert(res.msg);
			} 
	  
	  
		  });

	}
  }


  /*

  printBill() {
	var bill = this.bill;
	var imgData = this.logo;
	
	//@ts-ignore
	var doc = new jsPDF();
	
	doc.addImage(imgData, 'PNG', 7,2,40,10);
	doc.setFontSize(8);
	doc.text(200, 6, this.address, 'right');
	//doc.text(200, 10, "Phone: " + bill.phone, 'right');

	doc.text(10, 35, "Patient: " + bill.patient_name + " (" + bill.patient_id + ")"  );
	doc.text(10, 40, "Bill No.: " + bill.bill_no );
	doc.text(10, 45, "Bill Date: " + bill.bill_date );

	doc.setFontType('bold');

	doc.text(10, 55, 'Sl No.');
	doc.text(20, 55, 'Particulars');
	doc.text(100, 55, 'Rate', 'right');
	doc.text(120, 55, 'Quantity', 'right');
	doc.text(140, 55, 'HSN', 'right');
	doc.text(160, 55, 'GST Rate', 'right');
	doc.text(180, 55, 'GST Amt', 'right');
	doc.text(200, 55, 'Amount', 'right');
	doc.setFontType('normal');
	var i = 1;
	var y = 60;

	$.each(bill.bill_data, function(key, index){
		doc.text(10, y, i.toString());
		doc.text(20, y, this.item);
		doc.text(100, y, this.rate, 'right');
		doc.text(120, y, this.qty.toString(), 'right');
		doc.text(140, y, this.hsn_code, 'right');
		doc.text(160, y, this.gst_rate.toString(), 'right');
		doc.text(180, y, this.gst_amount, 'right');
		doc.text(200, y, this.amount, 'right');
		i++;
		y += 5;
	});

	//print total

	doc.setFontType('bold');
	doc.text(184, y+5, "CGST: " + bill.cgst);
	doc.text(184, y+10, "SGST: " + bill.sgst);
	doc.text(172, y+15, "Total Amount: " + bill.total);


	//output
	var string = doc.output('datauristring');
	var newWindow = window.open("", "PDF", 'dependent=yes,locationbar=no,scrollbars=no,menubar=no,resizable,screenX=50,screenY=50,width=850,height=800');
	newWindow.document.write(
	'<html><body><center>' +
	
	'</center><br>' +
	'<object width=100% height=100% type="application/pdf" data="'+string+'">' +
	'<embed type="application/pdf" src="'+string+'" id="embed_pdf"></embed>' +
	'</object></body></html>');
	newWindow.window.focus();

} */



}
